// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"1e2b7739","804":"66a946e4"}[chunkId] + ".chunk.css";
};